var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpiReady(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5606 8.31934V6.23926H2.08008C0.933956 6.23926 0 7.17321 0 8.31934V12.4795H14.9995C14.7103 11.2086 14.5606 9.83988 14.5606 8.31934Z",
    fill: "url(#paint0_linear_740_5000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.196 16.6396C31.7774 18.8258 29.6141 20.6854 26.5148 22.466C26.0384 22.7384 25.5018 22.8799 24.961 22.8799C24.4201 22.8799 23.8835 22.7384 23.4134 22.4701C20.3141 20.6854 18.1508 18.8237 16.7301 16.6396H0V27.04C0 28.1883 0.933956 29.1201 2.08008 29.1201H31.2012C32.3494 29.1201 33.2813 28.1883 33.2813 27.04V16.6396H33.196ZM9.36036 22.8799H5.2002C4.6261 22.8799 4.16016 22.414 4.16016 21.8398C4.16016 21.2657 4.6261 20.7998 5.2002 20.7998H9.36036C9.93446 20.7998 10.4004 21.2657 10.4004 21.8398C10.4004 22.414 9.93446 22.8799 9.36036 22.8799Z",
    fill: "url(#paint1_linear_740_5000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.651 3.20436L25.3707 0.0842432C25.1066 -0.0280811 24.8133 -0.0280811 24.5491 0.0842432L17.2688 3.20436C16.8882 3.36661 16.6406 3.7431 16.6406 4.15912V8.31928C16.6406 14.0416 18.7561 17.3863 24.443 20.6625C24.6032 20.754 24.7821 20.7998 24.9609 20.7998C25.1398 20.7998 25.3187 20.754 25.4789 20.6625C31.1658 17.3947 33.2813 14.0499 33.2813 8.31928V4.15912C33.2813 3.7431 33.0337 3.36661 32.651 3.20436ZM28.8944 7.9303L24.7342 13.1305C24.5345 13.376 24.235 13.5195 23.9209 13.5195C23.9063 13.5195 23.8897 13.5195 23.8772 13.5195C23.5465 13.5049 23.2407 13.3344 23.0556 13.0577L20.9755 9.93758C20.6573 9.45916 20.7862 8.81434 21.2646 8.49609C21.7389 8.17992 22.3858 8.30472 22.7061 8.78522L23.9979 10.7218L27.2678 6.63233C27.6276 6.18512 28.2828 6.1144 28.7301 6.47009C29.1793 6.82578 29.2501 7.48101 28.8944 7.9303Z",
    fill: "url(#paint2_linear_740_5000)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_5000",
    x1: 3.47039,
    y1: 9.76743,
    x2: 14.8917,
    y2: 9.76084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_5000",
    x1: 7.70022,
    y1: 23.696,
    x2: 33.0421,
    y2: 23.6798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_5000",
    x1: 20.4907,
    y1: 11.76,
    x2: 33.1617,
    y2: 11.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiReady);
export default __webpack_public_path__ + "static/media/upi-ready.0197072899d262770b7c471950ee86be.svg";
export { ForwardRef as ReactComponent };